/* CS Contact: snelkeuzechips zetten het onderwerp in de select (alleen
   desktop zichtbaar; progressive enhancement, de select werkt zonder JS). */
(() => {
  /* De theme editor voert sectiescripts opnieuw uit bij elke re-render;
     zonder guard stapelen de document-listeners zich op. */
  if (window.__csContactInit) return;
  window.__csContactInit = true;

  const initContact = (section) => {
    const root = section.querySelector('[data-cs-contact]');
    if (!root || root.dataset.csInit === '1') return;
    root.dataset.csInit = '1';

    const select = root.querySelector('[data-cs-onderwerp]');
    if (!select) return;
    root.querySelectorAll('[data-cs-chip]').forEach((chip) => {
      chip.addEventListener('click', () => {
        select.value = chip.value;
        select.focus();
      });
    });
  };

  document.querySelectorAll('.section-cs-contact').forEach(initContact);

  /* Theme editor rendert secties opnieuw zonder page load. */
  document.addEventListener('shopify:section:load', (event) => initContact(event.target));
})();
